export enum RedTeamSessionStatus {
  Pending = 'pending',
  Executing = 'executing',
  FinishedSuccess = 'finishedSuccess',
  FinishedFail = 'finishedFail',
}

export enum AssessmentScenario {
  SensitiveDataHunting = 'sensitive_data_hunting',
  ToolMisuse = 'tool_misuse',
  PolicyBypass = 'policy_bypass',
}
